/**
 * Anonymous session id used to link cookie / registration consents made before
 * a user logs in. Persisted in localStorage; created lazily on first read.
 */

const KEY = 'anon_session_id';

const generate = (): string => {
  if (typeof window !== 'undefined' && window.crypto?.randomUUID) {
    return window.crypto.randomUUID();
  }
  // Fallback for older browsers / SSR
  return `anon-${Date.now()}-${Math.random().toString(36).slice(2, 12)}`;
};

export const getAnonSessionId = (): string => {
  if (typeof window === 'undefined') return generate();
  try {
    let id = window.localStorage.getItem(KEY);
    if (!id) {
      id = generate();
      window.localStorage.setItem(KEY, id);
    }
    return id;
  } catch {
    return generate();
  }
};
